export default __webpack_public_path__ + "static/media/logo-ministry.bf60df8e.svg";